/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CollapsibleSidebar/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import CollapseAction from './CollapseAction/index'
import Filters from './Filters/index'
import LocationsChooser from './LocationsChooser/index'
import MonthAndYearSelector from './MonthAndYearSelector/index'
import MonthlyCalendar from './MonthlyCalendar/index'
import React from 'react'
import SelectedAppointmentTypesInfo from './SelectedAppointmentTypesInfo/index'
import SelectedProvidersInfo from './SelectedProvidersInfo/index'
import TysiaCollapsibleFloatingPortal from 'DesignSystem/TysiaCollapsibleFloatingPortal/react'
import UpdateTag from './UpdateTag/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function CollapsibleSidebar({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/CollapsibleSidebar",
  sidebarTopSpace,
  sidebarHeight,
  containerRef
  
}) {
let tabSidebarIsFloatingValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'sidebar.is_floating',
})
let tabSidebarIsFloatingAndVisibleValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'sidebar.is_floating_and_visible',
})
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
  return (<React.Fragment
>
<TysiaCollapsibleFloatingPortal
  viewPath={`${viewPath}/TysiaCollapsibleFloatingPortal`}
 data="tab.sidebar.is_floating"
 isFloating={tabSidebarIsFloatingValueData}
 placement="left-start"
 flexDirection="column"
 justifyContent="start"
 backgroundColor={dtColorsWhite}
 width={287}
 edgeThreshold={16}
 top={sidebarTopSpace}
 height={sidebarHeight}
 data="tab.sidebar.is_floating_and_visible"
 keepVisible={tabSidebarIsFloatingAndVisibleValueData}
 containerRef={containerRef}
>
{childProps => (
<div
  data-testid="CollapsibleSidebar.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="CollapsibleSidebar.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-1-ZDGN5r': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-2-ZDGN5r': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbc-3-ZDGN5r': dtColorsNeutral200}}
 className={`views-block ${styles.Horizontal}`}
>
<LocationsChooser
  viewPath={`${viewPath}/LocationsChooser`}
/>
<CollapseAction
  viewPath={`${viewPath}/CollapseAction`}
/>
</div>
<MonthAndYearSelector
  viewPath={`${viewPath}/MonthAndYearSelector`}
/>
<Filters
  viewPath={`${viewPath}/Filters`}
/>
<MonthlyCalendar
  viewPath={`${viewPath}/MonthlyCalendar`}
/>
<SelectedProvidersInfo
  viewPath={`${viewPath}/SelectedProvidersInfo`}
/>
<SelectedAppointmentTypesInfo
  viewPath={`${viewPath}/SelectedAppointmentTypesInfo`}
/>
<UpdateTag
  viewPath={`${viewPath}/UpdateTag`}
/>
</div>
)}
</TysiaCollapsibleFloatingPortal>
{children}
</React.Fragment>)
}